import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { LAYOUT } from "helpers/constants";

export const SidebarStyled = styled(Box)`
  background-color: rgb(255, 255, 255);
  background-image: none;
  border-right-color: rgba(0, 0, 0, 0.12);
  border-right-style: solid;
  border-right-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  width: ${LAYOUT.DRAWER_WIDTH}px;
  position: fixed;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  z-index: 1111;
`;

export const LogoWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  min-height: 56px;
  padding-top: 16px;
`;
